//const BACKEND_URL = 'http://localhost:5000'
//const BACKEND_URL = 'https://longitudinax.com'
const BACKEND_URL = 'https://longitudinax-pro.com'

export default BACKEND_URL
